import { P2GBox, P2GGrid, P2GLink, P2GText } from '@parcel2go/core-ui';
import { Customer } from '~/lib/api/smartsend/types';
import ErrorSummary from './ErrorSummary';
import { EditType } from './EditType';
import { CountryCache, GenCountryKey } from '../../../lib/cache/CountryCache';
import { P2GChip } from '@parcel2go/core-ui';
import { Truncate } from '../Truncate';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  errors?: string[];
  customer: Customer;
  edit?: (type: EditType) => void;
  revealText?: string;
  variant?: 'body2';
}

export default function ItemRecipient(props: props) {
  const onClick = () => props.edit && props.edit('ADDRESS');
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  return (
    <P2GBox p={1} data-sentry-mask>
      <P2GText variant={props.variant}>
        <strong>{props.customer.Name} </strong>
        {onClick && (
          <P2GLink variant="body2" ml={1} onClick={onClick}>
            {props.revealText || t('EDIT_LINK', 'Edit')}
          </P2GLink>
        )}
      </P2GText>
      <P2GBox mt={1}>
        <P2GText variant={props.variant}>
          <Truncate>
            {props.customer.AddressLine1} {props.customer.AddressLine2},<br />
          </Truncate>
          <Truncate>
            {props.customer.Postcode}, {CountryCache[GenCountryKey(props.customer)]?.LocalisedName}
          </Truncate>
        </P2GText>
        {props.customer?.Meta['buyerId']?.Value && (
          <P2GBox pt={1}>
            <P2GChip size="small" color="primary" label={props.customer?.Meta['buyerId']?.Value} />
          </P2GBox>
        )}
      </P2GBox>
    </P2GBox>
  );
}

export function ItemRecipientMobile(props: props & { children?: ReactElement }) {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  return (
    <P2GGrid container gap={1} alignContent="center" wrap="nowrap">
      <P2GGrid item flexGrow={1}>
        <ErrorSummary errors={props.errors} edit={() => {}} limit={1}>
          <P2GBox display="flex" gap={1} alignItems="center" wrap="nowrap">
            {props.children}
            <P2GText variant={props.variant} data-sentry-mask>
              <strong>{props.customer.Name}</strong>
              <br />
              {props.customer.AddressLine1} {props.customer.AddressLine2}, {props.customer.Postcode}
            </P2GText>
          </P2GBox>
        </ErrorSummary>
      </P2GGrid>
      {props.edit && (
        <P2GGrid item flexShrink={1}>
          <P2GLink variant={props.variant} onClick={() => props.edit('ADDRESS')}>
            {props.errors?.length ? t('FIX_LINK', 'Fix') : props.revealText || t('EDIT_LINK', 'Edit')}
          </P2GLink>
        </P2GGrid>
      )}
    </P2GGrid>
  );
}
